import script from "./TressCheckoutAddressViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressCheckoutAddressViewer.vue?vue&type=script&setup=true&lang=ts"

import "./TressCheckoutAddressViewer.vue?vue&type=style&index=0&id=8fa91efa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fa91efa"]])

export default __exports__